import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Input,
  Modal,
  ModalContent,
  ModalBody,
  ModalHeader,
  ModalFooter,
  useDisclosure,
} from "@heroui/react";
import MatchTable from "./MatchTable";
import MatchForm from "./MatchForm";
import { Spinner } from "@heroui/react";

const Match = () => {
  const navigate = useNavigate();
  const [matchDetails, setMatchDetails] = useState();
  const today = new Date().toISOString().split("T")[0];
  const [showForm, setShowForm] = useState(false);
  const [matchData, setMatchData] = useState([]);
  const [marketData, setMarketData] = useState([]);
  const [originalMatchDetails, setOriginalMatchDetails] = useState({});

  const [otpValue, setOtpValue] = useState("");
  const [matchId, setMatchId] = useState(null);

  const {
    isOpen: isMessageOpen,
    onOpen: onMessageOpen,
    onOpenChange: onMessageOpenChange,
    onClose: onMessageClose,
  } = useDisclosure();

  const {
    isOpen: isOpenOtp,
    onOpen: onOtpOpen,
    onOpenChange: onOtpOpenChange,
    onClose: onOtpClose,
  } = useDisclosure();

  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("alert");
  const [modalCallback, setModalCallback] = useState(null);
  const [modalAutoCloseMs, setModalAutoCloseMs] = useState(0);

  useEffect(() => {
    if (isMessageOpen && modalType === "alert" && modalAutoCloseMs > 0) {
      const timeoutId = setTimeout(() => {
        if (typeof modalCallback === "function") {
          const maybeFn = modalCallback();
          if (typeof maybeFn === "function") {
            maybeFn();
          }
        }
        if (typeof onMessageClose === "function") {
          onMessageClose();
        }
        setModalAutoCloseMs(0);
      }, modalAutoCloseMs);
      return () => clearTimeout(timeoutId);
    }
  }, [
    isMessageOpen,
    modalType,
    modalAutoCloseMs,
    modalCallback,
    onMessageClose,
  ]);

  const [formData, setFormData] = useState({
    name: "",
    is_active: true,
    matchDate: today,
  });

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const isEditing = !!formData.id;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

    const body = JSON.stringify({
      market_id: formData.market_id,
      name: formData.name,
      draw_date: formData.draw_date,
      open_time: formData.open_time,
      close_time: formData.close_time,
      is_active: formData.status === "active" ? 1 : 0,
      open_suspend: formData.open_suspend === "open_suspended" ? 1 : 0,
      close_suspend: formData.close_suspend === "close_suspended" ? 1 : 0,
      match_types: formData.match_types || [],
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/addmatch`,
        {
          method: "POST",
          headers,
          body,
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("Match saved successfully!");
        setShowForm(false);
        setFormData({
          name: "",
          marketname: "",
          matchDate: "",
          bettype: "",
          status: "active",
        });
        getMatches(); // refresh list
      } else {
        alert("Failed to save match.");
      }
    } catch (error) {
      console.error("Error saving match:", error);
      alert("Error saving match.");
    }
  };

  useEffect(() => {
    // This useEffect is no longer needed for scrolling and can be removed or repurposed.
    // I am removing it to avoid conflicts.
  }, []);

  const handleJodiReport = (matchId) => {
    navigate(`/operator/jodi-report/${matchId}`);
  };

  const handleEdit = (id) => {
    setShowForm(true);
    setTimeout(() => {
      const mainContainer = document.querySelector("main");
      if (mainContainer) {
        mainContainer.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 0);

    const fetchMatchById = async () => {
      try {
        setLoading(true); // Start loader
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append(
          "Authorization",
          "Bearer " + localStorage.getItem("jwt")
        );
        const payload = {
          match_id: id,
        };

        const response = await fetch(
          `${process.env.REACT_APP_API_HOST}/matches`,
          {
            method: "POST",
            headers,
            body: JSON.stringify(payload),
          }
        );
        const result = await response.json();

        if (
          !response.ok ||
          !result ||
          !result.data ||
          result.data.length === 0
        ) {
          alert("Failed to fetch match data.");
          return;
        }

        const items = result.data;

        const base = items[0]; // All rows share same match infobase

        // Set formData (general match info)
        setFormData({
          id: id,
          name: base.name || "",
          marketname: base.marketname || "",
          marketId: base.market_id || "",
          draw_date: base.draw_date ? base.draw_date.split("T")[0] : "",
          open_time: base.open_time?.slice(0, 5) || "",
          close_time: base.close_time?.slice(0, 5) || "",
          is_active: base.is_active?.data?.[0] === 1,
          open_suspend:
            base.open_suspend?.data?.[0] === 1 ? "open_suspended" : "",
          close_suspend:
            base.close_suspend?.data?.[0] === 1 ? "close_suspended" : "",
        });
        setLoading(false);

        // Build row-wise matchDetails based on type_id (1 to 5)
        const updatedMatchDetails = {
          row1: {
            selected: false,
            type_id: 1,
            rate: "",
            min_stake: "",
            max_stake: "",
          },
          row2: {
            selected: false,
            type_id: 2,
            rate: "",
            min_stake: "",
            max_stake: "",
          },
          row3: {
            selected: false,
            type_id: 3,
            rate: "",
            min_stake: "",
            max_stake: "",
          },
          row4: {
            selected: false,
            type_id: 4,
            rate: "",
            min_stake: "",
            max_stake: "",
          },
          row5: {
            selected: false,
            type_id: 5,
            rate: "",
            min_stake: "",
            max_stake: "",
          },
        };
        items.forEach((item) => {
          const rowKey = `row${item.type_id}`;
          console.log(rowKey);

          if (updatedMatchDetails[rowKey]) {
            updatedMatchDetails[rowKey] = {
              selected: true,
              type_id: item.type_id,
              rate: item.rate,
              min_stake: item.min_stake,
              max_stake: item.max_stake,
              isReadOnly: item.has_bets === 1,
            };
          }
        });
        // console.log(updatedMatchDetails, "lo");

        // Set bet-type rows
        setMatchDetails(updatedMatchDetails);
        // setOriginalMatchDetails(updatedMatchDetails);
        setShowForm(true);
      } catch (error) {
        console.error("Error fetching match data:", error);
        alert("Error fetching match.");
      }
    };

    fetchMatchById();
  };

  const handleDelete = (id) => {
    setModalMessage("Are you sure you want to delete this match?");
    setModalType("confirm");
    setModalCallback(() => () => {
      fetch(`${process.env.REACT_APP_API_HOST}/deletematch/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("jwt"),
        },
      })
        .then((res) => {
          if (res.status === 401) {
            console.log("Unauthorized access. Please log in again.");
            return null;
          }
          return res.json();
        })
        .then((result) => {
          if (result && result.success) {
            setModalMessage("Match deleted successfully!");
            setModalType("alert");
            setModalCallback(() => () => {
              getMatches();
            });
            setModalAutoCloseMs(1000);
            onMessageOpen();
          } else {
            setModalMessage(result?.message || "Failed to delete match.");
            setModalType("alert");
            setModalCallback(null);
            onMessageOpen();
          }
        })
        .catch((err) => {
          console.log("Error deleting match:", err);
          setModalMessage("Error deleting match.");
          setModalType("alert");
          setModalCallback(null);
          onMessageOpen();
        });
    });
    onMessageOpen();
  };
  // const handleAbandonMatch = (matchId, reason) => {
  //   setModalMessage("Are you sure you want to abandon this match?");
  //   setModalType("confirm");
  //   setModalCallback(() => () => {
  //     fetch(`${process.env.REACT_APP_API_HOST}/match/abandoned`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + localStorage.getItem("jwt"),
  //       },
  //       body: JSON.stringify({ match_id: matchId, reason }),
  //     })
  //       .then((res) => {
  //         if (res.status === 401) {
  //           console.log("Unauthorized access. Please log in again.");
  //           return null;
  //         }
  //         return res.json();
  //       })
  //       .then((result) => {
  //         if (result && result.success) {
  //           setTimeout(() => {
  //             setModalMessage("Match abandoned successfully!");
  //             setModalType("alert");
  //             setModalAutoCloseMs(1000);
  //             setModalCallback(() => () => {
  //               getMatches();
  //             });

  //             onMessageOpen(); // open modal
  //           }, 300); // 300ms delay
  //         } else {
  //           // Show error modal
  //           setModalMessage(result?.message || "Failed to abandon match.");
  //           setModalType("alert");
  //           setModalCallback(null);
  //           onMessageOpen();
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Error abandoning match:", err);
  //         setModalMessage("Error abandoning match.");
  //         setModalType("alert");
  //         setModalCallback(null);
  //         onMessageOpen();
  //       });
  //   });

  //   // Open the confirmation modal
  //   onMessageOpen();
  // };

  const handleAbandonMatch = async (matchId, reason) => {
    setLoading(true);
    setMatchId(matchId);
    try {
      await fetch(
        process.env.REACT_APP_API_HOST + "/send/otp/for/abandon/match",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("jwt"),
          },
          body: JSON.stringify({
            userId: localStorage.getItem("uid"),
            userName: localStorage.getItem("name"),
            mid: matchId,
          }),
        }
      );
    } catch (err) {
      console.error("OTP send failed:", err);
      alert("OTP send failed.");
    }
    setLoading(false);
    onOtpOpen();
  };

  const handleAbandon = async (matchId) => {
    fetch(`${process.env.REACT_APP_API_HOST}/match/abandoned`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
      body: JSON.stringify({ match_id: matchId }),
    }).catch((err) => {
      console.error("Error abandoning match:", err);
    });
    setTimeout(() => {
      setModalMessage("Match abandoned successfully!");
      setModalType("alert");
      setModalAutoCloseMs(1000);
      setModalCallback(() => () => {
        getMatches();
      });
      onMessageOpen();
    }, 300);
  };

  const getMatches = async () => {
    const userId = localStorage.getItem("uid");

    let headers = new Headers();
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

    const url = `${process.env.REACT_APP_API_HOST}/getmatch?user_id=${userId}`;

    const requestOptions = {
      method: "GET",
      headers: headers,
    };

    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.data) {
          setMatchData(result.data);
        }
      })
      .catch((err) => {
        console.log("Error fetching matches:", err);
      });
  };

  useEffect(() => {
    getMatches();
  }, []);

  const getMarkets = async () => {
    let headers = new Headers();
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

    const requestOptions = {
      method: "GET",
      headers: headers,
    };

    fetch(`${process.env.REACT_APP_API_HOST}/markets`, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result?.data) {
          setMarketData(result.data);
        }
      })
      .catch((err) => {
        console.log("Error fetching markets:", err);
      });
  };

  useEffect(() => {
    getMarkets();
  }, []);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Show spinner for 1 second on mount
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center">
        <Spinner size="lg" variant="spinner" color="warning" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-900">Matches</h2>
        <Button
          color="primary"
          className="bg-admin_black text-white"
          onClick={() => {
            if (!showForm) {
              // Only reset form when switching to "Add Match" mode
              setFormData({
                id: null,
                marketId: "",
                match_name: "",
                draw_date: "",
                open_time: "",
                close_time: "",
                open_suspend: false,
                close_suspend: false,
                is_active: true,
              });
              setMatchDetails({
                row1: {
                  selected: false,
                  type_id: 1,
                  rate: "",
                  min_stake: "",
                  max_stake: "",
                },
                row2: {
                  selected: false,
                  type_id: 2,
                  rate: "",
                  min_stake: "",
                  max_stake: "",
                },
                row3: {
                  selected: false,
                  type_id: 3,
                  rate: "",
                  min_stake: "",
                  max_stake: "",
                },
                row4: {
                  selected: false,
                  type_id: 4,
                  rate: "",
                  min_stake: "",
                  max_stake: "",
                },
                row5: {
                  selected: false,
                  type_id: 5,
                  rate: "",
                  min_stake: "",
                  max_stake: "",
                },
              });
            }
            setShowForm(!showForm);
          }}
        >
          {showForm ? "Cancel" : "Add Match"}
        </Button>
      </div>

      {showForm && (
        <MatchForm
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          onCancel={() => setShowForm(false)}
          setShowForm={setShowForm}
          getMatches={getMatches}
          matchData={matchData}
          marketData={marketData}
          matchDetails={matchDetails}
          setMatchDetails={setMatchDetails}
          originalMatchDetails={originalMatchDetails}
        />
      )}
      <MatchTable
        onEdit={handleEdit}
        onDelete={handleDelete}
        onAbandon={handleAbandonMatch}
        onJodiReport={handleJodiReport}
        matchData={matchData}
        getMatches={getMatches}
      />
      <Modal
        isOpen={isMessageOpen}
        onOpenChange={onMessageOpenChange}
        classNames={{
          backdrop: "bg-black/35",
          wrapper: "flex items-center justify-center min-h-screen",
        }}
      >
        <ModalContent>
          {(onClose) => (
            <>
              {modalType === "confirm" && (
                <>
                  <ModalBody className="flex items-start justify-center min-h-[60px]">
                    <p className="text-center font-semibold">{modalMessage}</p>
                  </ModalBody>
                  <ModalFooter className="-mt-4">
                    <Button color="danger" variant="light" onPress={onClose}>
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      onPress={() => {
                        if (typeof modalCallback === "function") {
                          const maybeFn = modalCallback();
                          if (typeof maybeFn === "function") {
                            maybeFn();
                          }
                        }
                        onClose();
                      }}
                    >
                      Yes
                    </Button>
                  </ModalFooter>
                </>
              )}

              {modalType === "alert" && (
                <>
                  <ModalBody className="flex items-center justify-center min-h-[80px]">
                    <p className="text-center font-semibold">{modalMessage}</p>
                  </ModalBody>
                </>
              )}
            </>
          )}
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenOtp} onOpenChange={onOtpOpenChange}>
        <ModalContent>
          {(onClose) => (
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                // if (!pendingRollback) return;

                try {
                  // verify OTP
                  const verifyRes = await fetch(
                    process.env.REACT_APP_API_HOST +
                      "/verify/otp/for/abandon/match",
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("jwt"),
                      },
                      body: JSON.stringify({
                        userId: localStorage.getItem("uid"),
                        otp: otpValue,
                      }),
                    }
                  );
                  const verifyData = await verifyRes.json();

                  console.log("OTP verify response:", verifyData);

                  if (!verifyData.success) {
                    setModalMessage("Invalid OTP / OTP expired");
                    setModalType("alert");
                    setModalCallback(null);
                    onMessageOpen();
                    return;
                  }

                  // finally call rollback with OTP
                  // handleRollBack(
                  //   pendingRollback.gameIndex,
                  //   pendingRollback.mmid,
                  //   pendingRollback.status,
                  //   pendingRollback.result,
                  //   pendingRollback.reason,
                  //   pendingRollback.value,
                  //   otpValue
                  // );
                  handleAbandon(matchId);

                  setOtpValue("");
                  // setPendingRollback(null);
                  onClose();
                } catch (err) {
                  console.error("OTP verify failed:", err);
                  alert("OTP verification failed.");
                }
              }}
            >
              <ModalHeader>Enter OTP</ModalHeader>
              <ModalBody>
                <Input
                  placeholder="Enter OTP"
                  value={otpValue}
                  onChange={(e) => setOtpValue(e.target.value)}
                  required
                />
              </ModalBody>
              <ModalFooter>
                <Button onPress={onClose}>Cancel</Button>
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </ModalFooter>
            </form>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};
export default Match;
